import { CustomRequestOptions } from '@/interceptors/request'
import { translate } from '@/locale/index'
import { isMp } from './platform'

const shoppingProxyPrefix = '/wujb'

function isRequestTimeoutLikeError(err: unknown): boolean {
  if (err == null) {
    return false
  }
  const errMsg =
    typeof err === 'string'
      ? err
      : typeof (err as { errMsg?: string }).errMsg === 'string'
        ? (err as { errMsg: string }).errMsg
        : typeof (err as { message?: string }).message === 'string'
          ? (err as { message: string }).message
          : ''
  return /timeout/i.test(errMsg)
}

export const http = <T>(options: CustomRequestOptions) => {
  // 1. 返回 Promise 对象
  return new Promise<IResData<T>>((resolve, reject) => {
    uni.request({
      ...options,
      dataType: 'json',
      // #ifndef MP-WEIXIN
      responseType: 'json',
      // #endif
      // 响应成功
      success(res) {
        // 状态码 2xx，参考 axios 的设计
        if (res.statusCode >= 200 && res.statusCode < 300) {
          // 2.1 提取核心数据 res.data
          resolve(res.data as IResData<T>)
        } else if (res.statusCode === 401) {
          // 401错误  -> 清理用户信息，跳转到登录页
          console.log(res)
          // uni.navigateTo({ url: '/pages/login/index' })
          reject(res)
        } else {
          // 其他错误 -> 根据后端错误信息轻提示
          !options.hideErrorToast &&
            uni.showToast({
              icon: 'none',
              title: (res.data as IResData<T>).msg || '请求错误',
            })
          reject(res)
        }
      },
      // 响应失败
      fail(err) {
        if (!options.hideErrorToast) {
          uni.showToast({
            icon: 'none',
            title: isRequestTimeoutLikeError(err)
              ? translate('http.networkWeakRetry')
              : translate('http.orderTooManyRetryLater'),
          })
        }
        resolve(err)
      },
    })
  })
}

/**
 * GET 请求
 * @param url 后台地址
 * @param query 请求query参数
 * @returns
 */
export const httpGet = <T>(
  url: string,
  query?: Record<string, any>,
  data?: Record<string, any>,
  requestOptions?: Partial<CustomRequestOptions>,
) => {
  if (!isMp && !/^https?:\/\//i.test(url) && !url.startsWith(shoppingProxyPrefix)) {
    url = '/api' + url
  }
  return http<T>({
    ...requestOptions,
    url,
    query,
    data,
    method: 'GET',
  })
}

/**
 * POST 请求
 * @param url 后台地址
 * @param data 请求body参数
 * @param query 请求query参数，post请求也支持query，很多微信接口都需要
 * @returns
 */
export const httpPost = <T>(
  url: string,
  data?: Record<string, any>,
  query?: Record<string, any>,
  requestOptions?: Partial<CustomRequestOptions>,
) => {
  if (!isMp && !/^https?:\/\//i.test(url) && !url.startsWith(shoppingProxyPrefix)) {
    url = '/api' + url
  }
  return http<T>({
    ...requestOptions,
    url,
    query,
    data,
    method: 'POST',
  })
}

http.get = httpGet
http.post = httpPost
